export default __webpack_public_path__ + "static/media/info-arrow-up-pos.696e2839.svg";